import { DatePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { CardComponent } from '@components/card/card.component';
import { environment } from '@environments/environment';
import { InHomeBookingResult } from '@Medology/ng-findalab';
import { OrderCompleteDetails } from '@models/order-complete-details';

@Component({
  selector: 'app-order-complete-instructions-stdcheck',
  templateUrl: './order-complete-instructions-stdcheck.component.html',
  imports: [CardComponent, DatePipe],
})
export class OrderCompleteInstructionsStdcheckComponent implements OnInit {
  @Input() public orderCompleteDetails: OrderCompleteDetails;

  public hasEmail: boolean;
  public isFree: boolean;
  public sendSms: boolean;
  public isPayLater: boolean;
  public inHomeBookingResult: InHomeBookingResult;

  public get cardContentClass(): string {
    return environment.styles.orderCompleteInstructions.cardContentClass;
  }

  public get myAccountUrl(): string {
    return environment.siteUrls.myAccount;
  }

  public get assistanceDetails(): string {
    return `If you have any questions or need assistance in the meantime, our Patient Services and
  Support teams are available ${environment.businessHours}.`;
  }

  public ngOnInit(): void {
    if (this.orderCompleteDetails) {
      this.hasEmail = this.orderCompleteDetails.hasEmail;
      this.isFree = this.orderCompleteDetails.free;
      this.sendSms = this.orderCompleteDetails.sendSms;
      this.isPayLater = this.orderCompleteDetails.isPayLater;
      this.inHomeBookingResult = this.orderCompleteDetails.inHomeBookingResult;
    }
  }
}
